import { register } from '@shopify/theme-sections'
import $ from 'jquery'
import '../../styles/sections/section-leadership-cards.scss'

export default register(`section-leadership-cards`, {
    onLoad() {
        $(document).on(`click`, `.leader-card-bio-link`, function() {
            $(this).parents(`.leader-card-main`).addClass(`active-bio`)
        })
        $(document).on(`click`, `.leader-card-bio-back`, function() {
            $(this).parents(`.leader-card-main`).removeClass(`active-bio`)
        })
    },
    onUnload() {

    }
})
